import { AnalyticsSender } from '@funtech-int/yango-shared';

import {
    counterOfferPageCancelButtonNavigated,
    counterOfferPageShowed,
    counterOfferPageSubscribeButtonNavigated,
    counterOfferPageTimeOutOverLimit,
} from '@kinopoisk-int/evgen-web-events/web/counter_offer_page';

interface CounterOfferAnalytics {
    showed(this: void): void;
    subscribeButtonNavigated(this: void, timeCheck: string): void;
    cancelButtonNavigated(this: void): void;
    timeOutOverLimit(this: void): void;
}

export function createCounterOfferAnalytics(eventSender: AnalyticsSender): CounterOfferAnalytics {
    return {
        showed() {
            eventSender.send(counterOfferPageShowed, {});
        },
        subscribeButtonNavigated(timeCheck) {
            eventSender.send(counterOfferPageSubscribeButtonNavigated, { timeCheck });
        },
        cancelButtonNavigated() {
            eventSender.send(counterOfferPageCancelButtonNavigated, {});
        },
        timeOutOverLimit() {
            eventSender.send(counterOfferPageTimeOutOverLimit, {});
        },
    };
}
